// @see https://gist.github.com/hrdtbs/990d67b6c74fec5990f13ec4144e079d
export const dispatchChangeEvent = (
  element: HTMLInputElement | HTMLTextAreaElement,
  value?: string | number,
) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    element.tagName.toLowerCase() === "input"
      ? HTMLInputElement.prototype
      : HTMLTextAreaElement.prototype,
    "value",
  )?.set;

  nativeInputValueSetter?.call(element, value);

  element.dispatchEvent(new Event("change", { bubbles: true }));
};
